import { Box, Button, Skeleton, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { getStories } from "../asiosConfig";
import Story from "./Story";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import storyImg1 from "../images/storyImg1.png";
import { toast } from "react-toastify";
import Footer from "./Footer";
import Navbar from "./Navbar";
import { StoryBox } from "./StoryBox";
import { Helmet } from "react-helmet-async";

import rangoliIcon from "../images/rangoliIcon.svg";

const StoryWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0),
}));
const StoryContent = styled(Typography)(({ theme }) => ({
  overflow: "hidden",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 3,
  textOverflow: "ellipsis",
}));
export const SuccessStories = () => {
  const [story, setStory] = useState([]);
  const [loading, setLoading] = useState(true);

  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    const fetchStories = async () => {
      try {
        const response = await getStories();
        if (response.status === 200 || response.status === 201) {
          setStory(response.data.data);
        } else {
          toast.error("Failed to fetch stories");
        }
      } catch (error) {
        console.log("Story API Error:", error);

        toast.error(
          error?.response?.data?.message ||
            "Failed to fetch stories. Please try again.",
        );
      } finally {
        setLoading(false);
      }
    };
    fetchStories();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options); // format as "13 July 2024"
  };
  return (
    <Box style={{ backgroundColor: "#f3f5f7" }}>
      <Helmet>
        <title>IND Matrimony Success Stories – Real Couples, Real Love</title>
        <meta
          name="description"
          content="Read inspiring success stories from IND Matrimony couples. Discover how verified profiles led to happy marriages and meaningful relationships on our platform."
        />
        <meta
          name="keywords"
          content="success stories matrimony, IND Matrimony couples, real love stories, verified profiles, happy marriages"
        />
        <meta
          property="og:title"
          content="IND Matrimony Success Stories – Real Couples, Real Love"
        />
        <meta
          property="og:description"
          content="Inspiring stories of couples who found love through IND Matrimony's verified matchmaking."
        />
        <meta property="og:image" content="%PUBLIC_URL%/indLogo.png" />
        <meta
          property="og:url"
          content="https://indmatrimony.in/success-story"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="IND Matrimony Success Stories" />
        <meta
          name="twitter:description"
          content="Real stories of love and marriage from IND Matrimony users."
        />
        <meta name="twitter:image" content="%PUBLIC_URL%/indLogo.png" />
        <link rel="canonical" href="https://indmatrimony.in/success-story" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "IND Matrimony Success Stories",
            url: "https://indmatrimony.in/success-story",
            description:
              "A collection of success stories from couples who found love through IND Matrimony.",
            isPartOf: {
              "@type": "WebSite",
              name: "IND Matrimony",
              url: "https://indmatrimony.in",
            },
          })}
        </script>
      </Helmet>
      <Navbar />
      <Box mb={5} sx={{ paddingTop: "100px" }}>
        <div className="container">
          <Box sx={{ textAlign: "center", mb: 1 }}>
            {loading ? (
              <>
                <Skeleton
                  variant="text"
                  width="40%"
                  height={50}
                  sx={{ mx: "auto", mb: 2 }}
                />
                <Skeleton
                  variant="text"
                  width="60%"
                  height={30}
                  sx={{ mx: "auto" }}
                />
              </>
            ) : (
              <>
                <Typography
                  sx={{
                    fontFamily: "Playfair Display, serif",
                    fontSize: { xs: "30px", md: "46px" },
                    fontWeight: 600,
                    mb: 2,
                  }}
                >
                  <span style={{ color: "#f37c20" }}>Ind Matrimony</span>{" "}
                  Success Stories
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "Montserrat",
                    color: "#6b6b6b",
                    maxWidth: "750px",
                    margin: "0 auto",
                    fontSize: "15px",
                    lineHeight: 1.7,
                  }}
                >
                  Every match is a success worth celebrating. These beautiful
                  couples found their perfect partners through IND Matrimony.
                  Share your joy with us and inspire others on their journey to
                  find love.
                </Typography>

                <Box sx={{ mt: 3 }}>
                  <img src={rangoliIcon} alt="divider" height="35" />
                </Box>
              </>
            )}
          </Box>

          {/* <div className="row justify-content-center align-items-center"> */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "30px",
            }}
          >
            {loading ? (
              Array.from(new Array(4)).map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  height={635}
                  sx={{ borderRadius: "30px" }}
                />
              ))
            ) : story.length === 0 ? (
              <Typography>No Story Found</Typography>
            ) : (
              // comment this in and the below one comment out to get a different way of grid

              // (showAll ? story : story.slice(0, 8)).map((item) => (
              //   <StoryBox key={item.auto_id} storyData={item} />
              // ))

              (showAll ? story : story.slice(0, 8)).map((item) => (
                <Box
                  key={item.auto_id}
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "48%",
                      md: "23%",
                    },
                  }}
                >
                  <StoryBox storyData={item} />
                </Box>
              ))
            )}
          </Box>

          {story.length > 8 && !showAll && (
            <Box
              onClick={() => setShowAll(true)}
              sx={{
                textAlign: "center",
                mt: 6,
                cursor: "pointer",
                fontFamily: "Montserrat",
                fontWeight: 600,
                fontSize: "14px",
                color: "#e60000",
              }}
            >
              View all Stories
              <span style={{ marginLeft: "6px" }}>⌄</span>
            </Box>
          )}
        </div>
      </Box>
      <Footer />
    </Box>
  );
};
